//DO NOT TOUCH WITHOUT PROPER PERMISSION

require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/agents_options.template.htm');
require('dhtmlxMessage');
var HandlebarsHelpers = require('../../libs/handlebars/handlebars-helpers.ts');
var AgentsModel = require('../models/agents.model.ts');
var UsersCollection = require('../models/users.paginated.collection.ts');
var i18n = require("l10n");

var TheView = GenericView.extend({
    el: '#agentsOptions',
    tagName: 'span',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	userPrivilege: null,
	id: null,
	isDisplay: false,
	editable: false,
    initiallyDeselected: [],
    initiallySelected: [],
	agentsToBeAdded: [],
	agentsToBeRemoved: [],
	allAgents: [],
	totalCalls: 0,
	callback: null,
	initialize: function (options) {
		var self = this;
		this.userPrivilege = options.userPrivilege;
		this.id = options.id;
		this.editable = options.editable;
		this.queueStatus = options.queueStatus;
		this.clearData();

		if(!this.isNewQueue())
		{
			this.showActionProgressBar();
			this.model = new AgentsModel();
			var url = "/rest/api/agents?filter=" + encodeURIComponent("queue=" + this.id);

			//fetches the already SELECTED agents
			this.model.fetch({
				url: url,
				success: function(response)
				{
					self.hideActionProgressBar();
				},
				error: function(response, xhr, status)
				{
					self.hideActionProgressBar();
				}
			});
		}
	},
	show: function()
	{
		this.render();
	},
	load: function(venueId)
	{
		if( venueId  == null)
		{
			this.show();
			return;
		}


		var self = this;
		if(!this.isDisplay || this.venueId != venueId)
		{

			this.clearData();
			this.initializeUsersCollection(venueId);
			this.showActionProgressBar();
			this.usersCollection.getFirstPage();

		}

		this.venueId = venueId;
	},
	initializeUsersCollection: function(venueId)
	{
		this.usersCollection = new UsersCollection();
		this.usersCollection.url = '/rest/api/users' + this.createFilters({venue: venueId, role: "VenueAgent"});
		this.usersCollection.on('sync', this.agentSuccess, this);
		this.usersCollection.on('error', this.agentError, this);
		this.usersCollection.state.pageSize = 999; //toDo:
	},
	createFilters: function(filter)
	{
		if( !filter )
			return "";

		var params = "";
		for (var key in filter) {

		  if(params != "")
				params = params + ",";

		  params = params + key + "="+filter[key];

		}

		return "?filter=" + encodeURIComponent(params);
	},
	isAgentIn: function(item, arrayData) {
	    return arrayData.filter(elem =>
	        item.id === elem.id
	    )[0];
	},
	agentSuccess: function()
	{
		var self = this;

        this.initiallySelected = [];
        this.initiallyDeselected = [];

        //all available agents for the selected Venue
        var agents = this.model ? this.model.toJSON() : {};

        var keys = Object.keys(agents);
        for(var i = 0; i < keys.length; i++) {
            var slctd = keys[i];

            //find the corresponding user Object
            var foundUser = this.usersCollection.models.filter(model => model.attributes.id == agents[slctd].userId)[0];
            if(foundUser) this.initiallySelected.push(foundUser.attributes);
        }

        this.allAgents = [];
        for(var index in this.usersCollection.models) {
            var obj = this.usersCollection.models[index];
            this.allAgents.push(obj.attributes);
        }

        this.initiallyDeselected = this.allAgents.filter(item => !self.isAgentIn(item, self.initiallySelected));

        this.clearData();

		this.hideActionProgressBar();
		this.render();
		if (this.usersCollection.length == 0){
		    $('#noagents').show();
		    this.areAgents = false;
		}
		else {
		    $('#noagents').hide();
		    this.areAgents = true;

		}
		this.showAgentData();
	},
	showAgentData: function() {
        var self = this;
        $('#myhelpingtext').hide();
        if (this.areAgents == true) {
            $("#multiselect").chosen({
                disable_search_threshold: 10,
                no_results_text: i18n.t("agent.nothing_found"),
                width: "100%"
            }).change(function(event){

            });
        }


	},
	agentError: function()
	{
		this.hideActionProgressBar();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;

		this.superRender();
		this.$el.html(this.template({ select: this.initiallySelected, unselect: this.initiallyDeselected}));

        if (this.editable)
            $('#myhelpingtext').hide();
	},
	events: {
	},
	isNewQueue: function()
	{
		return this.id ? false : true;
	},
	setNewQueueId: function(id)
	{
		this.id = id;
	},
	updateData: function(callback)
	{
	    var self = this;
        this.callback = callback;

        this.checkAndValidateSelectedDeselected();

        this.totalCalls = 2; //one for POST, one for DELETE

        //parameter: false => POST, true => DELETE
        this.doAjaxCall(false); //POST -> newly selected

/*console.log('this.agentsToBeRemoved.length: ', this.agentsToBeRemoved.length);
console.log('this.queueStatus: ', this.queueStatus);
console.log('canDelete: ', !(this.agentsToBeRemoved.length > 0 && this.queueStatus == i18n.t("queue.Open")));*/
        if(this.agentsToBeRemoved.length > 0 && this.queueStatus == i18n.t("queue.Open")) {

            //$.notify(i18n.t("queue.canNotRemoveAgentsOnOpenQueue"));
        }else {
            this.doAjaxCall(true); //DELETE -> newly deselected
        }
	},
	findSelectedUnselected: function() {
        var self = this;

        var stringIds = $("#multiselect").val() ? $("#multiselect").val() : [];

        for(var i=0; i<stringIds.length; i++) {
            var currentId = parseInt(stringIds[i]);
            var foundModel = $.grep(this.usersCollection.models, function(val) {
                return currentId === val.attributes.id;
            })[0];
            if(foundModel)
                this.initiallySelected.push(foundModel.attributes);
        }
        this.initiallyDeselected = this.allAgents.filter(item => !self.isAgentIn(item, self.initiallySelected));
    },
    areAgentsToBeDeleted: function() {
        this.checkAndValidateSelectedDeselected();
        return this.agentsToBeRemoved.length > 0;
    },
	checkAndValidateSelectedDeselected: function() {
	    var self = this;
	    var stringIds = $("#multiselect").val() ? $("#multiselect").val() : [];

        this.agentsToBeRemoved = [];
        this.agentsToBeAdded = [];

	    for(i=0; i<this.allAgents.length; i++) {
            var currentIteratedAgent = this.allAgents[i]; //contains User (model) object, so `userId` => `id`

            //stringIds contains all IDs as Strings

            var initiallySelectedAgent_DeselectedNow = this.initiallySelected.filter(item => item.id == currentIteratedAgent.id)[0]
                                                    && !stringIds.includes( currentIteratedAgent.id + "");
            var initiallyDeselectedAgent_SelectedNow = this.initiallyDeselected.filter(item => item.id == currentIteratedAgent.id)[0]
                                                    && stringIds.includes( currentIteratedAgent.id + "");

            //`this.agentsToBeAdded` contain Agent (model) objects
            var isInToBeAdded = this.agentsToBeAdded.filter(item => item.userId == currentIteratedAgent.id)[0];


            //`this.agentsToBeAdded` contain Agent (model) objects
            var isInToBeRemoved = this.agentsToBeRemoved.filter(item => item.userId == currentIteratedAgent.id)[0];

/*console.log("\n\n----------------------------------------")

console.log("currentIteratedAgent", (currentIteratedAgent.name + " " + currentIteratedAgent.userName));
console.log("wasDeselectedNow", initiallySelectedAgent_DeselectedNow);
console.log("wasSelectedNow", initiallyDeselectedAgent_SelectedNow);*/


            if( initiallySelectedAgent_DeselectedNow ) { // initiallySelectedAgent_DeselectedNow  =>  was deselected
                var agnt = this.initiallySelected.filter(item => item.id == currentIteratedAgent.id)[0];
                if( !isInToBeAdded && !isInToBeRemoved ) {
                    this.agentsToBeRemoved.push(this.getAgentObject(currentIteratedAgent));
                }
                else if( isInToBeAdded && !isInToBeRemoved ) {
                    this.agentsToBeRemoved.push(this.getAgentObject(currentIteratedAgent));
                    this.removeAgentFromArray(agnt, this.agentsToBeAdded);
                }
                else if( isInToBeAdded && isInToBeRemoved ) {
                    this.removeAgentFromArray(agnt, this.agentsToBeAdded);
                }
                else if( !isInToBeAdded && isInToBeRemoved ) {
                    //nothing
                }
            }
            else if(initiallyDeselectedAgent_SelectedNow) { // initiallyDeselectedAgent_SelectedNow  =>  was selected
                var agnt = this.initiallyDeselected.filter(item => item.id == currentIteratedAgent.id)[0];
                if( !isInToBeAdded && !isInToBeRemoved ) {
                    this.agentsToBeAdded.push(this.getAgentObject(currentIteratedAgent));
                }
                else if( !isInToBeAdded && isInToBeRemoved ) {
                    this.agentsToBeAdded.push(this.getAgentObject(currentIteratedAgent));
                    this.removeAgentFromArray(agnt, this.agentsToBeRemoved);
                }
                else if( isInToBeAdded && isInToBeRemoved ) {
                    this.removeAgentFromArray(agnt, this.agentsToBeRemoved);
                }
                else if( isInToBeAdded && !isInToBeRemoved ) {
                    //nothing
                }
            }
        }
/*console.log("---------------------------------------\n\n")
console.log("this.initiallySelected", this.initiallySelected);
console.log("this.initiallyDeselected", this.initiallyDeselected);
console.log("this.agentsToBeAdded", this.agentsToBeAdded);
console.log("this.agentsToBeRemoved", this.agentsToBeRemoved);*/
	},
	removeAgentFromArray: function(elem, arr) {
	    var self = this;

        //elem is USER (model) object, arr is a reference to Agent (model) objects array (`this.someAgentObjectArray`)
        var indexOfCurrentAgent;

        $.grep(arr, function(value, index) {
            if(arr.id == elem.id)
                indx = index;
            return arr.userId == elem.id;
        });

        arr.splice(indexOfCurrentAgent, 1); //remove the element on INDEX=indexOfCurrentAgent, and only 1 element
	},
	clearData: function()
	{
        this.agentsToBeAdded = [];
        this.agentsToBeRemoved = [];
	},
	clearView: function()
	{
		this.clearData();
		this.usersCollection = null;
		this.venueId = null;
		this.isDisplay = false;
		this.$el.removeClass("has-error");
		this.$el.html("");

	},
	doAjaxCall: function(isDelete)
	{
		var self = this;

		var url = "";
		var type = "";
		var data = "";
		this.totalCalls = this.totalCalls && this.totalCalls > 0 ? this.totalCalls - 1 : 0;
		if(isDelete)
		{
			if( this.agentsToBeRemoved.length == 0) {
			    if(this.totalCalls == 0 && this.callback && this.callback.success)
			        this.callback.success(true);
			    return;
			}

            //add agentId on the agents to be removed
            var agents = this.model.toJSON();
            var keys = Object.keys(agents);

            var toBeRemoved = [];
            for(var i = 0; i < keys.length; i++) {
                var slctd = keys[i];

                //find the corresponding user Object
                var foundUser = this.usersCollection.models.filter(model => model.attributes.id == agents[slctd].userId)[0];
                var foundToBeRemoved = this.agentsToBeRemoved.filter(item => item.userId == agents[slctd].userId)[0];
                if(foundUser && foundToBeRemoved) {
                    foundToBeRemoved.id = agents[slctd].id
                    toBeRemoved.push(foundToBeRemoved);
                }
            }

			url = '/rest/api/agents?';
			type = 'DELETE';
			var params = "";
			for (var i = 0; i < toBeRemoved.length; i++) {
			    if(params != "")
				    params = params + ",";
                params = params + toBeRemoved[i].id;
			}
			url = url +"ids=" + encodeURIComponent(params);
		}
		else
		{

		    if( this.agentsToBeAdded.length == 0) {
                if(this.totalCalls == 0 && this.callback && this.callback.success)
                    this.callback.success(true);
                return;
            }

			url = '/rest/api/agents/many';
			type = 'POST';
			data = this.agentsToBeAdded
		}

		this.showActionProgressBar();
		$.ajaxDefaultQ({
        	url: url,
        	type: type,
        	contentType: "application/json;charset=UTF-8",
        	data: JSON.stringify(data),
        }).done(function(response, status, xhr){
			if(self.totalCalls == 0 && self.callback && self.callback.success)
			    self.callback.success(response);

            //clear the data
            if(isDelete)
                self.agentsToBeRemoved = [];
            else
                self.agentsToBeAdded = [];

            self.initiallyDeselected = [];
            self.initiallySelected = [];
            self.findSelectedUnselected();

        	self.hideActionProgressBar();
        })
        .fail(function(response) {
			if(self.totalCalls == 0 && self.callback && self.callback.success)
				self.callback.success(response);

            //clear the data
            if(isDelete)
                self.agentsToBeRemoved = [];
            else
                self.agentsToBeAdded = [];

			self.hideActionProgressBar();
        });
	},
	getAgentObject: function(obj) {
	    return {
	        userId: obj.id,
	        queueId: this.id
	    };
	}
});

module.exports = TheView;